import { ColumnDetails } from '../../../grid/types/common';
import { getStatusWithBullet } from '../../../company/common/licensingTab/MdrUtils';
import { htmlEncode } from '../../../utils/escape.utils';
import { ProductServiceStatus } from '../../../license/types/ProductServiceStatus';
import { FontSizes } from '../../../types/common/types';
import { Column, ColumnKeys, MdrCompanyType } from '../types';
import moment from 'moment-timezone';
import { augmentTextWithValue, getPluralisedTextByDay, getTimezone } from '../../../utils/global.utils';
import { TimestampFormat } from '@nirvana/shared/time';
import { translateFn } from '../../../utils/translator.helper';

export function serviceStatusRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];

  const { bullet, mdrStatusText } = getStatusWithBullet(cellValue);

  const container = document.createElement('div');
  const statusText = `<gz-text class="has-bullet ${bullet} font-family-secondary" fontSize=${FontSizes.PARAGRAPH_13}>
    ${htmlEncode(mdrStatusText)}
  </gz-text>`;

  container.innerHTML = statusText;

  container.style['display'] = 'flex';
  container.style['width'] = '100%';
  container.style['align-items'] = 'center';
  container.style['margin-right'] = '16px';

  if (cellValue === ProductServiceStatus.INACTIVE && rowData.item['companyType'] === MdrCompanyType.CUSTOMER) {
    const daysUntilExpire = Math.max(rowData.item['daysUntilExpire'], 1);

    const translatedText = translateFn(
      'Please review your MDR service licensing. This company will be removed in',
    );

    const translatedUnitsText = getPluralisedTextByDay(daysUntilExpire);

    const tooltipText = augmentTextWithValue(daysUntilExpire, 1, translatedText, translatedUnitsText, '.');

    const toolTip = `<gz-tooltip tooltipText="${tooltipText}">
      <gz-icon name="ds-icon-notification_warning" size="24" color="var(--orange-layout-050-warning)"></gz-icon>
    </gz-tooltip>`;

    container.innerHTML = statusText + toolTip;
  }

  return container;
}

export function mdrDateRenderer(rowData, columnDetails: ColumnDetails<Column, ColumnKeys>) {
  const cellValue = rowData.item[columnDetails.key];

  let formattedDate = cellValue ? moment.utc(cellValue).tz(getTimezone()).format(TimestampFormat.EVENTS) : '-';

  const mdrServiceStatus = rowData.item[ColumnKeys.MDR_SERVICE_STATUS];
  if (mdrServiceStatus === ProductServiceStatus.ONBOARDING) {
    formattedDate = '-';
  }

  const container = document.createElement('div');
  container.innerHTML = `<gz-text class="content-text" fontSize=${FontSizes.PARAGRAPH_12}>${htmlEncode(
    formattedDate
  )}</gz-text>`;

  container.style['display'] = 'flex';
  container.style['width'] = '100%';
  container.style['align-items'] = 'center';

  return container;
}
